import _ from "lodash";

import RowedDescription from "../../components/rowedDescription";

const disabledRows = (rows: any) =>
  _.map(rows, (row, index) =>
    row[2] === "Brak miejsc" ? index : null
  ) as unknown as number[];

export const summer2026 = (rows: any) => ({
  header: "Letnie Campy Sportteam 2026",
  subheader: RowedDescription({
    rows: [
      ["Letni Camp Sportteam", "(dzieci 5-17 lat)"],
      ["Zakwaterowanie", "Baza Sportteam Jabłonkowy Las (Stare Jabłonki)"],
    ],
    suffixRow:
      "Zajęcia i pakiet atrakcji dopasowane do wieku oraz możliwości dzieci i nastolatków.",
  }),
  body: RowedDescription({
    rows,
    disabledRows: disabledRows(rows),
  }),
  path: "/summer2026",
  images: ["/images/funActive.jpeg"],
  accent: "Warning",
});

export const winter2027 = (rows: any) => ({
  header: "SKI & SNB SPORTTEAM CAMP 2027",
  subheader: RowedDescription({
    rows: [
      ["Turnus I", "(urodzeni 07.02.2009 - 01.01.2021)"],
      ["Turnus II", "(urodzeni 13.02.2009 - 01.01.2021)"],
    ],
    suffixRow:
      "Program zajęć oraz atrakcje dostosowane do wieku i możliwości dzieci.",
  }),
  body: RowedDescription({
    rows,
    disabledRows: disabledRows(rows),
  }),
  path: "/winter2027",
  images: ["/images/winter2026-1.jpeg"],
  accent: "Success",
});

export const winter2025Master = (rows: any) => {
  return {
    header: "ZIMOWE CAMPY 2026",
    subheader: RowedDescription({
      rows: [
        ["SKI&SNB MASTER CAMP", "(dzieci 6-11 lat)"],
        ["Zakwaterowanie", "U Pietrasa (Kaniówka)"],
      ],
      suffixRow:
        "Program zajęć oraz atrakcje dostosowane do wieku i możliwości dzieci.",
    }),
    body: RowedDescription({
      rows,
      disabledRows: disabledRows(rows),
    }),
    path: "/winter2026/master",
    images: ["/images/winter2026-1.jpeg"],
    accent: "Success",
  };
};

export const winter2025Adventure = (rows: any) => {
  return {
    header: "ZIMOWE CAMPY 2026",
    subheader: RowedDescription({
      rows: [
        ["SKI&SNB ADVENTURE CAMP", "(dzieci 12-17 lat)"],
        ["Zakwaterowanie", "U Korkoszów (Kaniówka)"],
      ],
      suffixRow:
        "Program zajęć oraz atrakcje dostosowane do wieku i możliwości dzieci.",
    }),
    body: RowedDescription({
      rows,
      disabledRows: disabledRows(rows),
    }),
    path: "/winter2026/adventure",
    images: ["/images/winter2026-2.jpeg"],
    accent: "Success",
  };
};

export const winter2023 = {
  header: "Zimowy obóz narciarsko-snowboardowy 2023",
  body: "Zapisy na Zimowisko 2023 już otwarte!",
  path: "/winter",
  images: ["/images/winter2025-1.jpeg"],
  accent: "Info",
};

export const sem_2_2022_2023 = {
  header: "Semester 2 2022/2023",
  body: "W koszyku znajdziesz wybrane dla Ciebie zapisy na zajęcia w semestrze 2.",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
};

export const sem_1_2023_2024 = {
  header: "Semester 1 2023/2024",
  body: "W koszyku znajdziesz wybrane dla Ciebie zapisy na zajęcia w semestrze 1.",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
};

export const sem_2_2023_2024 = {
  header: "Semester 2 2023/2024",
  body: "W koszyku znajdziesz wybrane dla Ciebie zapisy na zajęcia w semestrze 2.",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
};

export const sem_1_2024_2025 = {
  header: "1 Semestr 2024/2025",
  body: "W koszyku znajdziesz zapisy na wybrane przez Ciebie zajęcia w 1 semestrze 2024/2025",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
};

export const sem_2_2024_2025 = {
  header: "2 Semestr 2024/2025",
  body: "W koszyku znajdziesz zapisy na wybrane przez Ciebie zajęcia w 2 semestrze 2024/2025",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
};

export const sem_1_2025_2026 = {
  header: "1 Semestr 2025/2026",
  body: "W koszyku znajdziesz zapisy na wybrane przez Ciebie zajęcia w 1 semestrze 2025/2026",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
}

export const sem_2_2025_2026 = {
  header: "2 Semestr 2025/2026",
  body: "W koszyku znajdziesz zapisy na wybrane przez Ciebie zajęcia w 2 semestrze 2025/2026",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
}

export const sem_1_2026_2027 = {
  header: "1 Semestr 2026/2027",
  body: "W koszyku znajdziesz zapisy na wybrane przez Ciebie zajęcia w 1 semestrze 2026/2027",
  customButtonLabel: "Przejdź do koszyka",
  path: "/cart",
  images: ["/images/tenis.jpeg", "/images/plywanie.jpeg"],
  accent: "Info",
  isDisabled: true,
}